import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import {
    NotificationDetail, NotificationResponse, UnreadNotiResponse
} from '@models/notification/notification-response.model';

import { LanguageService } from './language.service';

import type { Notification } from '@models/notification/notification-response.model';
@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(
    private httpClient: HttpClient,
    private languageService: LanguageService
  ) {}
  isPopupOpen = signal(false);
  openPopup() {
    this.isPopupOpen.set(true);
  }
  closePopup() {
    this.isPopupOpen.set(false);
  }
  getNotifications(): Observable<NotificationResponse> {
    return this.httpClient.get<NotificationResponse>('notification?page=1&per_page=10000');
  }

  getDetailNotification(id: number): Observable<NotificationDetail> {
    return this.httpClient.get<NotificationDetail>(`notification/${id}`);
  }

  countUnreadNoti(): Observable<UnreadNotiResponse> {
    return this.httpClient.get<UnreadNotiResponse>('notification/unread-count');
  }

  markAsCheckNoti(id: number): Observable<NotificationResponse> {
    return this.httpClient.put<NotificationResponse>(`notification/mark-as-read/${id}`, {});
  }

  private readonly _notificationVisible = signal(false);
  public readonly notificationVisible = this._notificationVisible.asReadonly();

  private readonly _showDetail = signal(false);
  public readonly showDetail = this._showDetail.asReadonly();

  private readonly _notifications = signal<Notification[]>([]);
  public readonly notifications = this._notifications.asReadonly();

  private readonly _unReadMsgCount = signal<number | null>(null);
  public readonly unReadMsgCount = this._unReadMsgCount.asReadonly();

  private readonly _selectedNotification = signal<Notification | null>(null);
  public readonly selectedNotification = this._selectedNotification.asReadonly();

  initData() {
    const selectedLanguage = this.languageService?.currentLanguage?.lang ?? 'en';
    this.getNotifications().subscribe(({ notifications: { data } }) => {
      const mappedData = data.map(notif => {
        if(notif.announcement) {
          notif.announcement.subject = notif.announcement.subject[selectedLanguage];
          notif.announcement.subtitle = notif.announcement.subtitle[selectedLanguage];
        }
        return notif;
      });
      this._notifications.set(mappedData);
    });

    this.checkUnreadNoti();
  }

  checkUnreadNoti() {
    this.countUnreadNoti().subscribe(res => {
      this._unReadMsgCount.set(res.unread_notification_count);
    });
  }

  setShowDetail = (value: boolean) => {
    this._showDetail.set(value);
  };

  getDetail = (id: number) => {
    const selectedLanguage = this.languageService?.currentLanguage?.lang ?? 'en';
    this.getDetailNotification(id).subscribe(({ notification }) => {
      if(notification.announcement) {
        notification.announcement.subject = notification.announcement.subject[selectedLanguage];
        notification.announcement.subtitle = notification.announcement.subtitle[selectedLanguage];
        notification.announcement.app_content = notification.announcement.app_content[selectedLanguage];
      }
      this._selectedNotification.set(notification);
      this.setShowDetail(true);
      this.setNotificationVisible(true);
    });
  };

  setNotificationVisible = (value: boolean) => {
    this._notificationVisible.set(value);
  };
}
